import axios from 'axios';
import moment from 'moment';
import { Alert, t } from '@core/idtek-component';
import _ from "lodash"
import qs from "qs";

export default class AppUtil {
    static axios = axios;
    static moment = moment;

    static GLOBAL_DOMAIN_PATH = window.location.protocol + "//" + window.location.host;

    static GLOBAL_API_PATH = AppUtil.GLOBAL_DOMAIN_PATH + "/api";

    static GLOBAL_IMAGE_PATH = AppUtil.GLOBAL_DOMAIN_PATH + "/api/tenant/public";

    static GLOBAL_IMAGE_DOWNLOAD = AppUtil.GLOBAL_DOMAIN_PATH + "/api/file/download";

    static PUBLIC_URL = ""

    static GLOBAL_TENANT_API_PATH = AppUtil.GLOBAL_DOMAIN_PATH + "/api/tenant/public"


    static GLOBAL_SYMBOL_MONEY = "CAD";

    static GLOBAL_BOOKING_CONFIRMED = "";

    static GLOBAL_BOOKING_CONGRATULATIONS = "";

    static getApi = async (api: string, params?: any | undefined | null) => {
        const url = AppUtil.GLOBAL_API_PATH + api;
        let response;
        try {
            response = await AppUtil.axios.get(url, {
                params, paramsSerializer: params => {
                    return qs.stringify(params)
                }
            });
        } catch {
        }
        return response;
    };

    static postApi = async (api: string, params?: any | undefined | null) => {
        const url = AppUtil.GLOBAL_API_PATH + api;
        let response;
        try {
            response = await AppUtil.axios.post(url, params);
        } catch {
        }
        return response;
    };

    static deleteApi = async (api: string, params?: any | undefined | null) => {
        const url = AppUtil.GLOBAL_API_PATH + api;
        let response;
        try {
            response = await AppUtil.axios.delete(url, params);
        } catch {
        }
        return response;
    };

    static GetSymbolCurrency = () => {
        return this.GLOBAL_SYMBOL_MONEY;
    };

    static GetTitleBookingConfirm = () => {
        return this.GLOBAL_BOOKING_CONFIRMED;
    };

    static GetContentBookingConfirm = () => {
        return this.GLOBAL_BOOKING_CONGRATULATIONS;
    };

    static isNullOrUndefined = (value: any) => {
        return _.isNull(value) || _.isUndefined(value);
    };

    static ObjectToQuery(obj: any): string {
        return Object.entries(obj).map(([key, val]) => `${key}=${val}`).join('&');
    }

    static QueryToObject(str: string): any {
        const urlParams: any = new URLSearchParams(str);
        return Object.fromEntries(urlParams);
    }


    static ToastSuccess(message: string): void {
        Alert.Toast_info(t('NOTIFICATION'), message, 1);
    }

    static ToastError(message: string): void {
        Alert.Toast_info(t('ERROR'), message, 0);
    }

    static ToastWarning(message: string): void {
        Alert.Toast_info(t('WARNING'), message, 3);
    }

    static ToastWarningOptions(options: any): void {
        Alert.Toast_info(t('WARNING'), "", 3, options);
    }

    static RegexPhone(regex: string): any {
        let regexPhone = _.split(regex, ',') as any;
        _.map(regexPhone, (x, index) => {
            regexPhone[index] = _.toNumber(regexPhone[index])
        })
        const delimiter = []
        for (let i = 0; i < regexPhone.length; i++) {
            delimiter.push(' ')
        }
        const option =
        {
            blocks: regexPhone,
            delimiters: delimiter
        }
        return option
    }
}